import { useStaffAccess, type StaffAccess } from "../../../hooks/useIsStaffAdmin";

/**
 * ¿Quién entra a la app Equipo? (#1145)
 *
 * En CC-CONSOLE Equipo es de los DUEÑOS (Isaías y Daniel): ahí están los
 * sueldos de cada colaborador. Quién es dueño lo decide el servidor
 * (`GET /staffAccess`, correo verificado amarrado a su uid); el navegador
 * nunca lo adivina ni conoce los correos.
 *
 * Fuera de CC-CONSOLE (WAYAK/NUVEX/Dumax, mismo código) no rige la regla de
 * dueños y la app queda como estaba: el servidor recorta los importes por rol.
 *
 * - `loading`: todavía no responde el servidor. No se enseña el mosaico, pero
 *   tampoco se echa a nadie (un dueño no debe rebotar mientras carga).
 * - `allowed` / `denied`: la decisión ya está.
 *
 * Esto es para PINTAR; la autorización real vive en cada endpoint.
 */
export type TeamAccess = "loading" | "allowed" | "denied";

export function teamAccessOf(access: StaffAccess): TeamAccess {
  if (!access.resolved) return "loading";
  if (!access.ownerPolicy) return "allowed";
  return access.isStaffAdmin ? "allowed" : "denied";
}

export function useTeamAccess(enabled = true): TeamAccess {
  return teamAccessOf(useStaffAccess(enabled));
}

export default useTeamAccess;
